import styled from 'styled-components';

const InputCounter = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-size: 12px;
  text-align: right;
  color: ${({ theme }) => theme.colors.textSecondary};
  position: absolute;
  top: 54px;
  align-self: flex-end;
`;

export default InputCounter;
